import { logStartGreyError } from 'owa-analytics-start';
import tryGetGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/tryGetGlobalSettingsAccountMailboxInfo';
import { SourceIdPartDelimiter } from 'owa-client-types/lib/SourceIdPartDelimiter';

/**
 * Creates a sourceId from the three component parts
 * @param coprincipalSourceIdentifier The identifier for the coprincipal account, or the persistenceId when acctPersistenceIdBasedSourceIds is enabled
 * @returns a string represeting the source
 */
export function buildCoprincipalSourceId(coprincipalSourceIdentifier: string): string {
    if (!coprincipalSourceIdentifier) {
        const errorMessage = 'AcctSourceId_EmptyCoprincipalIdentifier';
        const e = new Error(errorMessage);
        // Using tryGetGlobalSettingsAccountMailboxInfo: This is infrastructure telemetry about
        // sourceId construction during early boot. No specific account mailbox is available
        // since the identifier is empty, and the store may not be initialized yet.
        logStartGreyError(
            'AcctSourceId_EmptyCoprincipalIdentifier',
            tryGetGlobalSettingsAccountMailboxInfo(false),
            e,
            {
                co: typeof coprincipalSourceIdentifier,
            }
        );
    }

    return coprincipalSourceIdentifier;
}

/**
 * Creates a sourceId from the three component parts
 * @param coprincipalSourceIdentifier The identifier for the coprincipal account, or the persistenceId when acctPersistenceIdBasedSourceIds is enabled
 * @param resourceType The type of resource
 * @param resourceSourceIdentifier The identifier for the resource account
 * @returns a string represeting the resource source
 */
export function buildResourceSourceId(
    coprincipalSourceIdentifier: string,
    resourceType: string,
    resourceSourceIdentifier: string
): string {
    if (!resourceSourceIdentifier) {
        const errorMessage = 'AcctSourceId_EmptyResourceIdentifier';
        const e = new Error(errorMessage);
        // Using tryGetGlobalSettingsAccountMailboxInfo: This is infrastructure telemetry about
        // sourceId construction during early boot. No specific account mailbox is available
        // since the identifier is empty, and the store may not be initialized yet.
        logStartGreyError(
            'AcctSourceId_EmptyResourceIdentifier',
            tryGetGlobalSettingsAccountMailboxInfo(false),
            e,
            {
                rt: resourceType, // resource type is non PII
                re: typeof resourceSourceIdentifier,
            }
        );
    }

    return [
        buildCoprincipalSourceId(coprincipalSourceIdentifier),
        resourceType,
        resourceSourceIdentifier,
    ].join(SourceIdPartDelimiter);
}
